import React from "react";
import {
  SlDrawer,
} from "@shoelace-style/shoelace/dist/react";
import NoDataFound from "../../shared/NoDataFound";
function POC(props) {
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  return (
    <>
      <SlDrawer
        label="POC"
        open={props.show}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={() => {
          props.setShow(false);
        }}
        style={{ "--size": `${window.innerWidth <= 767 ? '100%' :'43vw'}` }}
      >
        <table className="table table-bordered">
            <thead className="bg-gray-100">
                <tr>
                    <th>S.NO</th>
                    <th><div>
                    <p className="my-0" >
                      Name
                    </p>
                    <span className="block border-b border-gray-500 border-dashed"></span>
                    <p className="my-0">Designation</p>
                  </div></th>
                    <th><div>
                    <p className="my-0" >
                      Office Mail
                    </p>
                    <span className="block border-b border-gray-500 border-dashed"></span>
                    <p className="my-0">Personal Mail</p>
                  </div></th>
                    <th>Mobile</th>
                </tr>
            </thead>
            {props.contacts?.length > 0 ? <tbody>
                { props.contacts?.map((contact, index)=>{
                    return(<tr key={contact.contact_id}>
                        <td>{index+1}</td>
                        <td>
                            <p className="my-0 text-base font-medium" >{contact.name}</p>
                            <p className="my-0 text-xs text-gray-500" >{contact.designation}</p>
                        </td>
                        <td>
                            <p className="my-0 text-base font-medium" >{contact.official_email || "-"}</p>
                            <p className="my-0 text-xs  text-gray-500" >{contact.personal_email || "-"}</p>
                        </td>
                        <td>
                            {contact.mobile || "-"}
                        </td>
                    </tr>)
                })}
            </tbody> : <NoDataFound  colspan={4}/>}
        </table>
      </SlDrawer>
    </>
  );
}

export default POC;
